import React from 'react';
import PropTypes from 'prop-types';
import { StaticRouter, Router } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import { routerHistory } from './routing-lib';
import ScrollToTop from '../components/shared/scroll-to-top';

class RoutedContent extends React.Component {

  render() {
    const { location, component, defaultComponent, routes } = this.props;

    const routedContent =
      (<Switch>
        {routes.map((route, index) => {
          return (<Route
            key={index}
            path={route.path}
            exact={route.exact || false}
            component={component ? component : route.component}
          />);
        })}
        {defaultComponent && <Route component={defaultComponent}/>}
      </Switch>);

    if (!process.env.BROWSER) {
      return (
        <StaticRouter location={location} context={{}}>
          {routedContent}
        </StaticRouter>
      );

    } else {
      let history = routerHistory.getHistory();
      return (
        <Router history={history}>
          <ScrollToTop>
            {routedContent}
          </ScrollToTop>
        </Router>
      );
    }
  }
}

RoutedContent.propTypes = {
  location: PropTypes.string,
  component: PropTypes.func,
  defaultComponent: PropTypes.func,
  routes: PropTypes.array.isRequired
};


export default RoutedContent;
